<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { AppConfirmationModal } from '@libs/ui';

interface ContinueWithSelectedDateModalProps {
  tripDateRange: string | undefined;
  tripNumberOfNights: number | undefined;
}

const props = defineProps<ContinueWithSelectedDateModalProps>();

interface ContinueWithSelectedDateModalEmits {
  (eventName: 'confrim'): void;
  (eventName: 'close'): void;
}

const emit = defineEmits<ContinueWithSelectedDateModalEmits>();

const statsigEventsStore = useStatsigEventsStore();

function confirm(): void {
  statsigEventsStore.logTripOverviewContinueWithSelectedDateModalConfirmed();
  emit('confrim');
}

function close(): void {
  statsigEventsStore.logTripOverviewContinueWithSelectedDateModalCancelled();
  emit('close');
}
</script>

<template>
  <AppConfirmationModal
    class="continue-with-selected-date-modal"
    :show-close-button="false"
    @close="close"
    @cancel="close"
    @confirm="confirm"
  >
    <template #title>
      <span>
        {{ $t('date_confirmation_modal.continue_with_date_selected') }}
      </span>
    </template>
    <template #content>
      <div class="content">
        <span>{{ $t('date_confirmation_modal.our_suggestion') }}</span>

        <span class="date">
          {{ props.tripDateRange }}
          <span class="number-of-nights">
            &nbsp;({{ props.tripNumberOfNights }}
            {{ $t('planner.nights', props.tripNumberOfNights || 1) }})
          </span>
        </span>
      </div>
    </template>
    <template #cancelButton>
      <span>{{ $t('date_confirmation_modal.select_date') }}</span>
    </template>
    <template #applyButton>
      <span>{{ $t('date_confirmation_modal.continue_with_suggestion') }}</span>
    </template>
  </AppConfirmationModal>
</template>

<style scoped lang="scss">
.continue-with-selected-date-modal {
  .content {
    display: flex;
    flex-direction: column;
    .date {
      font: var(--font-body-l-bold);
      color: var(--color-secondary-40);
      white-space: nowrap;

      .number-of-nights {
        text-transform: lowercase;
      }
    }
  }
}
</style>
